const clickSound = new Audio('https://cdn.shopify.com/s/files/1/0633/1059/4244/files/soundpop.MP3?v=1783469924');
clickSound.preload = 'auto';

document.addEventListener('click', function (e) {
  const clickedButton = e.target.closest('button, a, [role="button"], input[type="submit"]');

  if (!clickedButton) return;

  clickSound.currentTime = 0;
  clickSound.play().catch(function () {});
});